import ButtonBasic from "@rentiohq/shared-frontend/dist/components/components/ButtonBasic";
import ButtonPrimary, {
  EButtonSize,
} from "@rentiohq/shared-frontend/dist/components/components/ButtonPrimary";
import FormInputText from "@rentiohq/shared-frontend/dist/components/components/FormInputText";
import Spacer, {
  ESpacerWeight,
} from "@rentiohq/shared-frontend/dist/components/components/Spacer";
import * as authActions from "@rentiohq/shared-frontend/dist/redux/auth/auth.actions";
import * as authApi from "@rentiohq/shared-frontend/dist/redux/auth/auth.api";
import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import { showAlert } from "@rentiohq/shared-frontend/dist/utils/alert/alert.utils";
import { isValidEmail } from "@rentiohq/shared-frontend/dist/utils/email.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { htmlTextAsReactText } from "@rentiohq/shared-frontend/dist/utils/text/text.utils";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import InfoHeader from "../../../../components/InfoHeader";
import Page from "../../../../components/Page";
import * as S from "./EditEmail.styles";

export const EditEmail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = authHooks.useSelf();

  const [email, setEmail] = React.useState(user?.unverifiedEmail ?? "");
  const [error, setError] = React.useState<string | null>(null);

  const handleFormSubmit = async () => {
    if (!isValidEmail(email)) {
      setError(getLocalizedText("system.form.error.invalid_email"));
      return;
    }

    setError(null);

    try {
      const updatedUser = await authApi.updateUser({
        unverifiedEmail: email,
      });
      dispatch(authActions.updateUser.actions.success({ user: updatedUser }));
      // The backend sends the verification email automatically (afterSave hook)
      // once unverifiedEmail is set, so no explicit resend is needed here.
      navigate("/auth/verify/email");
    } catch {
      showAlert({ type: "error", message: getLocalizedText("general.error") });
    }
  };

  return (
    <Page>
      <InfoHeader
        title={getLocalizedText("edit_email.info.title")}
        body={htmlTextAsReactText(
          getLocalizedText("verify_email.info.description", {
            email: user?.unverifiedEmail || "",
          }),
        )}
      />
      <Spacer weight={ESpacerWeight.W24} />
      <S.FormWrap>
        <FormInputText
          title={getLocalizedText("system.email")}
          value={email}
          onChangeValue={setEmail}
          error={error ?? undefined}
          textInputProps={{
            autoFocus: true,
          }}
        />
        <Spacer weight={ESpacerWeight.W16} />
        <ButtonPrimary
          title={getLocalizedText("system.next")}
          buttonSize={EButtonSize.Full}
          onPress={handleFormSubmit}
        />
        <Spacer weight={ESpacerWeight.W16} />
        <ButtonBasic
          title={getLocalizedText("system.cancel")}
          onPress={() => navigate("/auth/verify/email")}
        />
      </S.FormWrap>
    </Page>
  );
};

// eslint-disable-next-line import/no-default-export
export default EditEmail;
